import React, { Fragment } from 'react';
import { always, identity, ifElse } from 'ramda';
import { LegendOrdinal, LegendItem } from '@vx/legend';

import { LegendContainer, Container, LegendLabel, legendLabelStyle, legendItemStyle } from './legend.styles';
import { INDICATOR_SIZE, INDICATOR_HALF_SIZE, NO_COLUMNS_LIMIT } from './legend.constants';
import { useIntl } from 'gatsby-plugin-intl';

const renderLabelItem = (labels) => ({ value, text }, index) => {
  const intl = useIntl();
  return (
    <LegendItem key={`legend-item-${index}`} {...legendItemStyle}>
      <svg width={INDICATOR_SIZE} height={INDICATOR_SIZE}>
        <circle fill={value} r={INDICATOR_HALF_SIZE} cx={INDICATOR_HALF_SIZE} cy={INDICATOR_HALF_SIZE} />
      </svg>
      <LegendLabel {...legendLabelStyle}>{intl.formatMessage({ id: labels[text] || text })}</LegendLabel>
    </LegendItem>
  );
};

const renderColumns = (labels, className) => (labelsList) => {
  const count = labelsList.length;
  const hasColumns = count > NO_COLUMNS_LIMIT;

  const columns = ifElse(
    identity,
    () => {
      const halfIndex = Math.ceil(count / 2);

      return [labelsList.slice(0, halfIndex), labelsList.slice(halfIndex, count)];
    },
    always([labelsList])
  )(hasColumns);

  return (
    <Fragment>
      {columns.map((column, columnIndex) => (
        <Container className={className} key={columnIndex}>
          {column.map(renderLabelItem(labels))}
        </Container>
      ))}
    </Fragment>
  );
};

export const Legend = ({ colorScale, labels = {}, className }) => {
  return (
    <LegendContainer>
      <LegendOrdinal scale={colorScale}>{renderColumns(labels, className)}</LegendOrdinal>
    </LegendContainer>
  );
};
